import type { AllarmeSconosciutoDTO } from '@/models/dto/allarme/allarme-sconosciuto-dto'
import type { UnknownAlarm } from '@/models/types/alarm/unknown-alarm'
import { isAllarmeDinamico, isDynamicAlarm } from '@/utils/alarms'
import { mapToAllarmeDinamicoDTO, mapToDynamicAlarm } from './dynamic-alarm-mapper'
import { mapToAllarmeStaticoDTO, mapToStaticAlarm } from './static-alarm-mapper'

const mapToUnknownAlarm = (dto: AllarmeSconosciutoDTO): UnknownAlarm => {
    if (isAllarmeDinamico(dto)) {
        return mapToDynamicAlarm(dto)
    }
    return mapToStaticAlarm(dto)
}

const mapToAllarmeSconosciutoDTO = (alarm: UnknownAlarm): AllarmeSconosciutoDTO => {
    if (isDynamicAlarm(alarm)) {
        return mapToAllarmeDinamicoDTO(alarm)
    }
    return mapToAllarmeStaticoDTO(alarm)
}

export { mapToAllarmeSconosciutoDTO, mapToUnknownAlarm }
